import React, { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';

import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { UniversalPopup } from '@/components/UniversalPopup';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import TrademarkRegistration from '@/pages/TrademarkRegistration';
import CopyrightRegistration from '@/pages/CopyrightRegistration';
import TrademarkSearch from '@/pages/TrademarkSearch';
import CompanyFormation from '@/pages/CompanyFormation';
import AmazonBrandRegistry from '@/pages/AmazonBrandRegistry';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import LandingPage from '@/pages/LandingPage';
import ApplicationMain from '@/pages/application/ApplicationMain';

function Layout({ children, onOpenPopup }) {
  const location = useLocation();
  const isLandingPage = location.pathname === '/lp';

  return (
    <div className="flex flex-col min-h-screen">
      {!isLandingPage && <Header onOpenPopup={onOpenPopup} />}
      <main className="flex-grow">{children}</main>
      {!isLandingPage && <Footer />}
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  const [popupOpen, setPopupOpen] = useState(false);

  const handleOpenPopup = () => setPopupOpen(true);

  return (
    <div className="App scroll-smooth">
      <HelmetProvider>
        <BrowserRouter>
          <Layout onOpenPopup={handleOpenPopup}>
            <Routes>
              <Route path="/" element={<Home onOpenPopup={handleOpenPopup} />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/services/trademark-registration"
                element={<TrademarkRegistration onOpenPopup={handleOpenPopup} />}
              />
              <Route
                path="/services/copyright-registration"
                element={<CopyrightRegistration onOpenPopup={handleOpenPopup} />}
              />
              <Route
                path="/services/trademark-search"
                element={<TrademarkSearch onOpenPopup={handleOpenPopup} />}
              />
              <Route
                path="/services/company-formation"
                element={<CompanyFormation onOpenPopup={handleOpenPopup} />}
              />
              <Route
                path="/services/amazon-brand-registry"
                element={<AmazonBrandRegistry onOpenPopup={handleOpenPopup} />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/lp" element={<LandingPage />} />
              <Route path="/application/main" element={<ApplicationMain />} />
            </Routes>
          </Layout>
          <UniversalPopup open={popupOpen} onOpenChange={setPopupOpen} />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
